import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@material-ui/core";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import debounce from "lodash.debounce";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import SimpleBackdrop from "utils/general";
import { CommonConfig } from "CommonConfig";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { MultiSelect } from "primereact/multiselect";
import { ToggleButton } from "primereact/togglebutton";
import ReactToPrint from "react-to-print";
import Barcode from "react-barcode";

const initialFilterData = {
  DateRange: [],
  Input1: true, // And
  Warehouse: [],
  Input2: true, //And
  Supplier: [],
};

const Inward = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [inwardList, setInwardList] = useState([]);
  const [inwardId, setInwardId] = useState();
  const [inwardPrintId, setInwardPrintId] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [warehouseList, setWarehouseList] = useState(false);
  const [supplierList, setSupplierList] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterData, setFilterData] = useState(initialFilterData);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [productList, setProductList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [barcodeData, setBarcodeData] = useState([]);
  const [content, setContent] = useState({
    header: "",
    footer: "",
    image: "",
  });
  const printButtonRef = useRef(null);
  const componentRef = useRef(null);

  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const access = localStorage.getItem("PageAccess");

    if (token) {
      setUserId(data);
      setUserPageAccess(access);
      fetchInwardList(data);
      GetSupplierList(data);
      GetWarehouseMaster(data);
      GetImageConfiguration(data);
      GetProductMaster(data);
      GetVariantMaster(data);
      if (props.location?.state && props.location.state.InwardId) {
        setInwardPrintId(props.location.state.InwardId);
      }
    } else {
      props.history.push("/login");
    }
  }, []);

  useEffect(() => {
    debouncedSearch(userId, search);
  }, [search]);

  useEffect(() => {
    if (productList.length && variantList.length) {
      if (inwardPrintId) {
        handleOpen("", "Print");
      }
    }
  }, [productList, variantList]);

  const debouncedSearch = useCallback(
    debounce((userId, keyword) => {
      fetchInwardList(userId, {}, keyword);
    }, 400),
    []
  );

  const fetchInwardList = async (userId, event = {}, query = "") => {
    setLoading(true);
    const params = {
      UserId: userId,
      page: event.first ? event.first / rowsPerPage : 0,
      limit: event.rows || rowsPerPage,
      Query: query || "",
    };

    try {
      const response = await api.post(APIConstant.path.GetInward, params);
      if (response.Success === 1) {
        setInwardList(response.Data);
        setTotalRecords(response.TotalRecords);
        setFirst(event.first || 0);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const GetImageConfiguration = async (UserId) => {
    try {
      let paramData = {
        UserId: UserId,
      };
      await api
        .post(APIConstant.path.GetImageConfiguration, paramData)
        .then(async (response) => {
          let resp = await response;
          if (resp?.success) {
            const image = `${process.env.REACT_APP_NODE_API_ENDPOINT}/document/${resp?.data[0]?.ImagePath}`;
            setContent({
              header: resp?.data[0]?.Header,
              footer: resp?.data[0]?.Description,
              image: image,
            });
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetProductMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          setProductList(
            response.Data.filter((product) =>
              product.Type?.includes("Finished Product")
            )
          );
        }
      })
      .catch((err) => {});
  };

  const GetVariantMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setVariantList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetSupplierList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Supplier",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setSupplierList(filterArry);
        }
      })
      .catch(() => {});
  };

  const GetWarehouseMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (item) => ({
              ...item,
              label: item.Name,
              value: item._id,
            })
          );
          setWarehouseList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetInwardById = async (InwardId) => {
    try {
      let params = {
        UserId: userId,
        InwardId,
      };
      api
        .post(APIConstant.path.GetInwardById, params)
        .then((response) => {
          if (response.Success === 1) {
            const { InwardDate, ItemList } = response.Data;
            let tempItemList = [];
            let productIds = productList.map((item) => item._id);
            ItemList.forEach((item) => {
              let variant = variantList.find((v) => v.value === item.ItemId);
              if (productIds.includes(variant.Product)) {
                tempItemList.push({
                  InwardDate: InwardDate,
                  MfgDate: item.MfgDate,
                  BatchNo: item.BatchNo,
                  ExpiryDate: item.ExpiryDate,
                  ItemName: item.ItemName,
                  Barcode: item.BarcodeNo,
                  Weight: item.Quantity + item.UnitName,
                  MRP: item.Mrp,
                  Rate: item.RateIncludingGST,
                });
              }
            });
            setBarcodeData(tempItemList);
            if (printButtonRef) {
              printButtonRef.current.click();
            }
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  const deleteInward = async (e) => {
    try {
      let params = {
        InwardId: inwardId,
        UserId: userId,
      };
      await api
        .post(APIConstant.path.DeleteInward, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setInwardId("");
            setShowDeleteModal(false);
            await fetchInwardList(userId, 0);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const generatePdf = async (e) => {
    try {
      let params = {
        UserId: userId,
        FilterData: {
          ...filterData,
          Input1: !!filterData.Input1 ? "And" : "Or",
          Input2: !!filterData.Input2 ? "And" : "Or",
        },
      };
      await api
        .post(APIConstant.path.GenerateInwardPdf, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setShowFilterModal(false);
            setFilterData(initialFilterData);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleOpen = (data = {}, type = "Add") => {
    if (type === "Add") {
      props.history.push("/admin/add-inward");
    } else if (type === "View") {
      props.history.push({
        pathname: "/admin/add-inward",
        state: {
          InwardId: data?._id,
          Type: "View",
        },
      });
    } else if (type === "Edit") {
      props.history.push({
        pathname: "/admin/add-inward",
        state: {
          InwardId: data?._id,
          Type: "Edit",
        },
      });
    } else if (type === "Delete") {
      setShowDeleteModal(true);
      setInwardId(data._id);
    } else if (type === "Print") {
      if (data) {
        GetInwardById(data._id);
      } else GetInwardById(inwardPrintId);
    }
  };

  const actionTemplate = (rowData) => (
    <div className="icon-only-btn p-d-flex p-ai-center">
      {userPageAccess?.includes("Print Inward") && (
        <i
          className="pi pi-print"
          onClick={() => handleOpen(rowData, "Print")}
        ></i>
      )}
      {userPageAccess?.includes("Edit Inward") && (
        <i
          className="icon-editImage"
          onClick={() => handleOpen(rowData, "Edit")}
        ></i>
      )}
      {userPageAccess?.includes("View Inward") && (
        <i
          className="icon-view"
          onClick={() => handleOpen(rowData, "View")}
        ></i>
      )}
      {userPageAccess?.includes("Delete Inward") ? (
        <div onClick={(e) => handleOpen(rowData, "Delete")}>
          <i class="icon-delete"></i>{" "}
        </div>
      ) : null}
    </div>
  );

  const onPageChange = (e) => {
    setRowsPerPage(e.rows);
    fetchInwardList(userId, e, search);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-arrow-up-right"></i>
          <h2>Inward</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!search ? <i className="icon-search"></i> : null}
          </div>
          <div
            className="e-add-btn"
            onClick={(e) => {
              setShowFilterModal(true);
            }}
          >
            <i className="pi pi-file-excel"></i>
          </div>
          {userPageAccess?.includes("Add Inward") ? (
            <div>
              <div className="e-add-btn" onClick={(e) => handleOpen(e, "Add")}>
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
      {loading ? <SimpleBackdrop /> : null}
      <DataTable
        className="main-table table-td e-company-table"
        value={inwardList}
        paginator
        rows={rowsPerPage}
        totalRecords={totalRecords}
        lazy
        onPage={onPageChange}
        first={first}
        emptyMessage="No records found"
        responsiveLayout="scroll"
        editMode="row"
        dataKey="id"
        rowsPerPageOptions={rowsPerPageOptions}
        globalFilter={search}
        responsive={false}
        resizableColumns={true}
        columnResizeMode="fit"
        scrollable={true}
        scrollWidth="auto"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      >
        <Column header="Sr. No" body={(data, props) => props.rowIndex + 1} />
        <Column
          field="InwardDate"
          header="Inward Date"
          body={(rowData) => moment(rowData.InwardDate).format("DD/MM/YYYY")}
        />
        <Column field="OrderNo" header="Order No" />
        <Column field="InvoiceNo" header="Invoice No" />
        <Column
          field="ItemName"
          header="Raw Material/Item"
          body={(rowData) =>
            rowData.ItemList.map((item) => item.ItemName).join(", ")
          }
        />
        <Column field="SupplierName" header="Supplier Name" />
        <Column field="GSTIN" header="GSTIN" />
        <Column
          field="TotalAmountExcludingGST"
          header="Total Amt (Excl. GST)"
        />
        <Column
          field="TotalAmountIncludingGST"
          header="Total Amt (Incl. GST)"
        />
        <Column body={actionTemplate} header="Actions" />
      </DataTable>

      <Dialog
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setInwardId("");
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Inward</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowDeleteModal(false);
              setInwardId("");
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete this?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowDeleteModal(false);
              setInwardId("");
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteInward(e)}
            type="submit"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showFilterModal}
        onClose={() => {
          setShowFilterModal(false);
          setFilterData(initialFilterData);
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Apply Filters</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowFilterModal(false);
              setFilterData(initialFilterData);
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <GridItem md={4}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select">Date range</label>
                  <Calendar
                    // ref={calendarRef}
                    className="wb-filter-dt"
                    placeholder="Start Date - End Date"
                    value={filterData.DateRange}
                    onChange={(e) => {
                      setFilterData((prevState) => ({
                        ...prevState,
                        DateRange: e.value,
                      }));
                    }}
                    selectionMode="range"
                    dateFormat="dd/mm/yy"
                  />
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={2}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select"></label>
                  <div className="pill-toggle p-mt-3">
                    <ToggleButton
                      onLabel="And"
                      offLabel="Or"
                      checked={filterData.Input1}
                      onChange={(e) => {
                        setFilterData((prevState) => ({
                          ...prevState,
                          Input1: e.value,
                        }));
                      }}
                      // className={!filterData.Input1 ? "active" : ""}
                    />
                  </div>
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={4}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select">Warehouse</label>
                  <MultiSelect
                    value={filterData.Warehouse}
                    onChange={(e) =>
                      setFilterData((prevState) => ({
                        ...prevState,
                        Warehouse: e?.value,
                      }))
                    }
                    options={warehouseList}
                    optionLabel="label"
                    placeholder="Godown"
                    className="w-full md:w-20rem"
                  />
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={2}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select"></label>
                  <div className="pill-toggle p-mt-3">
                    <ToggleButton
                      onLabel="And"
                      offLabel="Or"
                      checked={filterData.Input2}
                      onChange={(e) => {
                        setFilterData((prevState) => ({
                          ...prevState,
                          Input2: e.value,
                        }));
                      }}
                      // className={!filterData.Input1 ? "active" : ""}
                    />
                  </div>
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={6}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select">Supplier</label>
                  <MultiSelect
                    value={filterData.Supplier}
                    onChange={(e) =>
                      setFilterData((prevState) => ({
                        ...prevState,
                        Supplier: e?.value,
                      }))
                    }
                    options={supplierList}
                    optionLabel="label"
                    placeholder="Supplier"
                    className="w-full md:w-20rem"
                  />
                </FormControl>
              </div>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowFilterModal(false);
              setFilterData(initialFilterData);
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => generatePdf()}
            type="submit"
          >
            Generate Pdf
          </Button>
        </DialogActions>
      </Dialog>

      <ReactToPrint
        trigger={() => (
          <div className="p-d-none">
            <button ref={printButtonRef}>Print</button>
          </div>
        )}
        content={() => componentRef?.current}
        documentTitle="Inward"
        onAfterPrint={() => {
          setBarcodeData([]);
          setInwardPrintId("");
        }}
      />

      <div className="p-d-none">
        <div className="im-p-dp" ref={componentRef}>
          {barcodeData.map((item, index) => (
            <div className="p-d-flex p-ai-baseline p-jc-center" key={index}>
              {/* Print the same QR code twice */}
              {[1].map((_, duplicateIndex) => (
                <div key={duplicateIndex}>
                  <div className="im-print-main">
                    <div className="p-d-flex">
                      {content.image ? (
                        <p>
                          <img src={content.image} />
                        </p>
                      ) : null}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: content.header,
                        }}
                      ></p>
                    </div>
                    <div className="im-print">
                      <p className="im-name">
                        {item.ItemName ? item.ItemName : ""}
                      </p>
                      <p className="im-pcs">
                        {item.Weight ? `Net Weight:${item.Weight}` : ""}
                      </p>
                      <p className="im-weight">
                        {item.MfgDate
                          ? `Packed On: ${moment(item.MfgDate).format(
                              "DD/MM/YYYY"
                            )}`
                          : ""}
                      </p>
                      <p className="im-final">
                        {item.ExpiryDate
                          ? `Best Before: ${moment(item.ExpiryDate).format(
                              "DD/MM/YYYY"
                            )}`
                          : ""}
                      </p>

                      <p className="im-qc-check">
                        {item.BatchNo ? `Batch No: ${item.BatchNo}` : ""}
                      </p>
                      {/* <p className="im-final">{item.MRP ? item.MRP : ""}</p> */}

                      <p className="im-final">
                        {item.Rate ? `Price: ${item.Rate}` : ""}
                      </p>

                      <p className="im-qr">
                        {item.Barcode ? <Barcode value={item.Barcode} /> : ""}
                      </p>
                      {/* <p className="im-qr-bottom">
                              {item.BarcodeName ? item.BarcodeName : ""}
                            </p> */}
                    </div>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: content.footer,
                      }}
                    ></p>
                  </div>
                </div>
              ))}
              {/* Page break after every set of 2 identical QR codes */}
              <div style={{ pageBreakAfter: "always" }}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Inward;
